import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { clearImageData } from "../redux-toolkit/slices/imageSlice";
import { MdAirplanemodeActive, MdAirplanemodeInactive } from "react-icons/md";
import { FaUserTie } from "react-icons/fa";
import {
  MDBInput,
  MDBBadge,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from "mdb-react-ui-kit";
import fromatDateintoDDMMMMYYYY from "../utilities/fromatDateintoDDMMMMYYYY";
import dummyFingerprint from "../assets/images/dummyFingerPrint.jpg";
import dummyProfileImage from "../assets/images/dummyPhoto.png";
import dummySignature from "../assets/images/dummySignature.png";
import API_BASE_URL from "../utilities/apiConfig";
import "../styles/newuserform.css";
import useWindowSize from "../customhooks/useWindowSize";
import Loader from "../components/Loader";
import ScannerLoader from "../components/ScannerLoader";
import CameraPopup from "../components/CameraPopup";
import { useSelector } from "react-redux";
import axios from "axios";
import validateUserCreationForm from "../utilities/validateUserCreationForm";
import { MdPublishedWithChanges } from "react-icons/md";
import axiosInstance from "../utilities/apiConfig";

export default function UserCreationFrom() {
  const [roleAndResponsibilitiesModal, setRoleAndResponsibilitiesModal] =
    useState(false);
  const [isFingerPrintScannerinProgress, setIsFingerPrintScannerinProgress] =
    useState(false);
  const [showCameraModalPopup, setShowCameraModalPopup] = useState(false);
  const [secugenLic, setSecugenLic] = useState("");
  const [fingerprintImage, setFingerprintImage] = useState(dummyFingerprint);
  const [profileImage, setProfileImage] = useState(dummyProfileImage);
  const [users, setUsers] = useState([]);
  const [refresh, setRefresh] = useState(0);
  const [update, setUpdate] = useState(false);

  const [loading, setLoading] = useState(false);
  const initialUserCreationStates = {
    email: "",
    mobileNumber: "",
    password: "",
    fingerprintData: "",
    role: "",
    profileImage: "",
    userName: "",
  };

  const [userCreationForm, setUserCreationForm] = useState(
    initialUserCreationStates
  );
  const [userDetailsUpdateForm, setUserDetailsUpdateForm] = useState({
    ...initialUserCreationStates,
    userId: "",
  });

  const dispatch = useDispatch();

  const handleCameraModalPopupClose = () => setShowCameraModalPopup(false);
  const handleCameraModalPopupShow = () => setShowCameraModalPopup(true);
  const token = useSelector((state) => state.auth.token);
  // const token =
  //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1laWQiOiJkY2JiMWQ3NS00OTIyLTQ1NmQtYjMzMC1jN2UwM2UwODA5NGUiLCJlbWFpbCI6ImFsb2trQGdhbWlsLmNvbSIsInJvbGUiOiJTdXBlciBBZG1pbiIsIm5iZiI6MTcyODk3NTQwNywiZXhwIjoxNzI4OTc5MDA3LCJpYXQiOjE3Mjg5NzU0MDcsImlzcyI6IllvdXJJc3N1ZXIiLCJhdWQiOiJZb3VyQXVkaWVuY2UifQ.dT9B2Lpa3dwozMog1uhQf2NBKvNJiJEA5UejLNhmdNg";

  const profileImageData = useSelector(
    (state) => state.profileimage?.imageData
  );

  const size = useWindowSize();

  let modalSize;
  let heightAndWidth;
  if (size.width < 768) {
    modalSize = "sm"; // Mobile: Small size
    heightAndWidth = 240;
  } else if (size.width >= 768 && size.width < 1400) {
    modalSize = "lg"; // Tablet: Large size
    heightAndWidth = 360;
  } else {
    modalSize = "xl"; // Desktop: Extra large size
    heightAndWidth = 480;
  }

  const roles = [
    { role: "Super Admin", responsibilities: "Owner with All rights" },
    {
      role: "Cashier",
      responsibilities: "Voucher Selling  and other responsibilities",
    },
    {
      role: "Accountants",
      responsibilities: "Fees Payment and other responsibilities",
    },
    {
      role: "Computer Operator",
      responsibilities: "Verifiaction of Advocates and other responsibilities",
    },
    {
      role: "Election",
      responsibilities: "Voting of Advocates",
    },
  ];

  const toggleRoleAndResponsibilitiesOpen = () =>
    setRoleAndResponsibilitiesModal(!roleAndResponsibilitiesModal);

  const successFunc2 = (result) => {
    setIsFingerPrintScannerinProgress(false);
    if (result.ErrorCode === 0) {
      if (result != null && result.BMPBase64.length > 0) {
        setUserCreationForm({
          ...userCreationForm,
          fingerprintData: result.TemplateBase64,
        });
        setUserDetailsUpdateForm({
          ...userDetailsUpdateForm,
          fingerprintData: result.TemplateBase64,
        });
        // setFingerPrintVoting(result.TemplateBase64);
        setFingerprintImage("data:image/bmp;base64," + result.BMPBase64);
        // handleVerifyFingerPrint(result.TemplateBase64);
      }
    } else {
      if (result.ErrorCode === 3) {
        toast.error("Please check your fingerprint device");
      } else if (result.ErrorCode === 54) {
        toast.error("Timeout, scan your finger again");
      } else {
        toast.error("Please scan your finger again");
      }
      console.log("Finger print error in user creation page ", result);
      // alert(Fingerprint Capture Error Code: ${result.ErrorCode}.\nDescription: ${errorCodeToString(result.ErrorCode)}.);
    }
  };

  const errorFunc = (status) => {
    setIsFingerPrintScannerinProgress(false);
    toast.error("Please Check Secugen fingerprit service is working properly");
    // alert(Check if SGIBIOSRV is running; status = ${status}:);
  };

  const callSGIFPGetData = (successCall, failCall) => {
    setIsFingerPrintScannerinProgress(true);
    const uri = "https://localhost:8000/SGIFPCapture";
    const params = `Timeout=10000&Quality=50&licstr=${encodeURIComponent(
      secugenLic
    )}&templateFormat=ISO`;

    fetch(uri, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: params,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Network response was not ok.");
        }
      })
      .then((data) => {
        successCall(data);
      })
      .catch((error) => {
        failCall(error);
      });
  };

  const handleInputFieldChange = (e) => {
    const { name, value } = e.target;
    if (name === "mobileNumber" && value.length > 10) {
      return;
    }
    setUserCreationForm({ ...userCreationForm, [name]: value });
    setUserDetailsUpdateForm({ ...userDetailsUpdateForm, [name]: value });

    console.log("Handle Input Field Change", "=>", name, " : ", value);
  };

  // const handleCreateNewUser = async (e) => {
  //   e.preventDefault();
  //   debugger;
  //   console.log("Sending User Creation Form Data", userCreationForm);
  //   const validationErrors = validateUserCreationForm(userCreationForm);
  //   if (Object.keys(validationErrors).length > 0) {
  //     Object.values(validationErrors).forEach((error) => {
  //       toast.error(error);
  //     });
  //   } else {
  //     try {
  //       const response = await axios.post(
  //         `${API_BASE_URL}/Admin/create_new_user`,
  //         userCreationForm
  //       );
  //       console.log("user creation response", response.data);
  //       if (response.data.status_code === 200) {
  //         toast.success(response.data.status);
  //         setRefresh(refresh + 1);
  //         setUserCreationForm(initialUserCreationStates);
  //       } else {
  //         toast.error(response.data.status);
  //       }
  //     } catch (error) {
  //       console.log("error from user creation api", error);
  //       toast.error("An Unexpected error occured please try again");
  //     }
  //   }
  // };

  // changes by khalid starts

  const handleCreateNewUser = async (e) => {
    e.preventDefault();
    //debugger;
    // Retrieve JWT from localStorage or wherever it's stored

    console.log("Sending User Creation Form Data", userCreationForm);
    const validationErrors = validateUserCreationForm(userCreationForm);

    if (Object.keys(validationErrors).length > 0) {
      Object.values(validationErrors).forEach((error) => {
        toast.error(error);
      });
    } else {
      try {
        // Add the JWT token to the Authorization header
        const response = await axiosInstance.post(
          `/Admin/create_new_user`,
          userCreationForm,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the request header
            },
          }
        );

        console.log("user creation response", response.data);
        if (response.data.status_code === 200) {
          toast.success(response.data.status);
          setRefresh(refresh + 1);
          setUserCreationForm(initialUserCreationStates);
        } else {
          toast.error(response.data.status);
        }
      } catch (error) {
        console.log("error from user creation api", error);
        toast.error("An unexpected error occurred. Please try again.");
      }
    }
  };

  // changes by khalid ends

  const fetchUserDetails = async () => {
    try {
      const response = await axiosInstance.get(`/Admin/get_all_user_list`, {
        headers: {
          Authorization: `Bearer ${token}`, // Token Added By Khalid
        },
      });
      setUsers(response.data.users);
      console.log("user list of all data", response.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const updateUserStatus = async (userId) => {
    try {
      setLoading(true);
      console.log(userId);
      const response = await axiosInstance.put(
        `/Admin/update_user_status/${userId}`,
        {
          headers: {
            "Content-Type": "application/problem+json; charset=utf-8",
            Authorization: `Bearer ${token}`, // Include the token in the request header
          },
        }
      );

      // Check if response status code is 200
      if (response.status === 200) {
        toast.success(response.data.response.status);
        setRefresh(refresh + 1);
      } else {
        toast.error("Failed to update user status");
      }
    } catch (error) {
      console.error("Error updating user status:", error);
      toast.error("Error updating user status");
    } finally {
      setLoading(false);
    }
  };

  const handleGetUserDetailsById = async (userId) => {
    try {
      const response = await axiosInstance.get(
        `/Admin/get_user_details_by_id/${userId}`
      );
      console.log("user data from user creation =>", response.data);
      if (response.data.statusCode === 200) {
        toast.success("user data fetched successfully");
        setUserCreationForm(response.data.authUser);
        setUpdate(true);
        setProfileImage(response.data.authUser?.profileImage);
        setUserDetailsUpdateForm(response.data?.authUser);
      } else {
        toast.error(response.data.status);
      }
    } catch (error) {
      console.log("Error while fetching the user details", error);
      toast.error(
        "Error occured while fetching the user data please try again"
      );
    }
  };

  const hadleUpdateDetailsById = async (e) => {
    e.preventDefault();
    console.log("Sending User UPdate Form Data", userDetailsUpdateForm);
    const validationErrors = validateUserCreationForm(userDetailsUpdateForm);
    if (Object.keys(validationErrors).length > 0) {
      Object.values(validationErrors).forEach((error) => {
        toast.error(error);
      });
    } else {
      try {
        const response = await axiosInstance.put(
          `/Admin/update_user_details`,
          userDetailsUpdateForm,
          {
            headers: {
              "Content-Type": "application/problem+json; charset=utf-8",
              Authorization: `Bearer ${token}`, // Include the token in the request header
            },
          }
        );
        console.log("user update response", response.data);
        if (response.data.status_code === 200) {
          toast.success(response.data.status);
          setRefresh(refresh + 1);
          setUserDetailsUpdateForm({
            ...initialUserCreationStates,
            userId: "",
          });
          setProfileImage(dummyProfileImage);
        } else {
          toast.error(response.data.status);
        }
      } catch (error) {
        console.log("error from user update api", error);
        toast.error("An Unexpected error occured please try again");
      }
    }
  };

  const handleSetInitialState = () => {
    setUpdate(false);
    setUserCreationForm(initialUserCreationStates);
    setProfileImage(dummyProfileImage);
  };

  useEffect(() => {
    if (profileImageData) {
      setProfileImage(profileImageData);
      setUserCreationForm({
        ...userCreationForm,
        profileImage: profileImageData,
      });
      setUserDetailsUpdateForm({
        ...userDetailsUpdateForm,
        profileImage: profileImageData,
      });
    }
    console.log("image data of verification page", profileImageData);
  }, [profileImageData]);

  useEffect(() => {
    dispatch(clearImageData());
  }, []);

  useEffect(() => {
    fetchUserDetails();
  }, []);

  useEffect(() => {
    fetchUserDetails();
    handleSetInitialState();
  }, [refresh]);

  return (
    <>
      {loading && <Loader />}
      {isFingerPrintScannerinProgress && <ScannerLoader />}
      <CameraPopup
        show={showCameraModalPopup}
        handleClose={handleCameraModalPopupClose}
      />
      <div className="row justify-content-center mt-5">
        <div className="col-xxl-10 ">
          <div className="row">
            <div className="col-md-6 align-self-center">
              {update ? (
                <h3 className="mb-4 ms-5">
                  Update Details | Create New User{" "}
                  <MDBBtn
                    onClick={() => {
                      handleSetInitialState();
                    }}
                    rounded
                    size="sm"
                  >
                    <FaUserTie />
                  </MDBBtn>{" "}
                </h3>
              ) : (
                <h3 className="mb-4 ms-5">Create New User</h3>
              )}

              <div className="row justify-content-start mb-3 justify-content-around">
                <div className="col-xl-5 col-md-6 col-sm-5 align-self-end">
                  <MDBInput
                    onChange={(e) => {
                      handleInputFieldChange(e);
                    }}
                    id="userName"
                    name="userName"
                    value={userCreationForm.userName}
                    wrapperClass="mb-4"
                    label="Name"
                  />
                </div>
                <div className="col-xl-5 col-md-6 col-sm-5 align-self-end">
                  <MDBInput
                    type="email"
                    onChange={(e) => {
                      handleInputFieldChange(e);
                    }}
                    id="email"
                    name="email"
                    value={userCreationForm.email}
                    wrapperClass="mb-4"
                    label="Email address"
                  />
                </div>
              </div>

              <div className="row justify-content-start mb-3 justify-content-around">
                <div className="col-xl-5 col-md-6 col-sm-5 align-self-end">
                  <MDBInput
                    type="number"
                    pattern="\d{10}" // Enforce digits only
                    onChange={(e) => {
                      handleInputFieldChange(e);
                    }}
                    maxLength={10}
                    id="mobileNumber"
                    name="mobileNumber"
                    value={userCreationForm.mobileNumber}
                    wrapperClass="mb-4"
                    label="Phone No"
                  />
                </div>
                <div className="col-xl-5 col-md-6 col-sm-5 align-self-end">
                  <MDBInput
                    onFocus={(e) => {
                      e.target.type = "text";
                    }}
                    onBlur={(e) => {
                      e.target.type = "password";
                    }}
                    type="password"
                    onChange={(e) => {
                      handleInputFieldChange(e);
                    }}
                    wrapperClass="mb-4"
                    id="password"
                    name="password"
                    value={userCreationForm.password}
                    label="Password"
                  />
                </div>
              </div>

              <div className="row justify-content-start mb-3 justify-content-around">
                <div className="col-xl-5 col-md-6 col-sm-5 align-self-end">
                  <div className="form-group mb-4">
                    <label className="form-label" htmlFor="role">
                      Select Role
                    </label>
                    <select
                      className="form-select"
                      onChange={(e) => {
                        handleInputFieldChange(e);
                      }}
                      id="role"
                      name="role"
                      value={userCreationForm.role}
                    >
                      <option value="" defaultValue>
                        Select
                      </option>
                      <option value="Super Admin">Super Admin</option>
                      <option value="Cashier">Cashier</option>
                      <option value="Accountant">Accountant</option>
                      <option value="Computer Operator">
                        Computer Operator
                      </option>
                      <option value="Election">Election</option>
                      {/* Add more options here */}
                    </select>
                  </div>
                </div>
                <div className="col-xl-5 col-md-6 col-sm-5 align-self-end">
                  <MDBBtn
                    className="mb-4 w-100 text-center"
                    onClick={toggleRoleAndResponsibilitiesOpen}
                  >
                    About Roles of Users
                  </MDBBtn>
                </div>
              </div>

              <div className="row justify-content-center">
                <div className="col-xm-10 row justify-content-center">
                  <div className="col-md-5 d-flex justify-content-center">
                    {update ? (
                      <>
                        <MDBBtn
                          onClick={(e) => {
                            hadleUpdateDetailsById(e);
                          }}
                          type="submit"
                          color="primary"
                          className="my-4"
                          block
                        >
                          Update Details
                        </MDBBtn>{" "}
                        &nbsp;
                      </>
                    ) : (
                      <MDBBtn
                        onClick={(e) => {
                          handleCreateNewUser(e);
                        }}
                        type="submit"
                        className="my-4"
                        block
                      >
                        Create New User
                      </MDBBtn>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="row justify-content-start">
                <div className="col-xl-4 col-md-6 col-sm-5">
                  <MDBCard>
                    <MDBCardBody>
                      <MDBBtn onClick={handleCameraModalPopupShow}>+</MDBBtn>
                    </MDBCardBody>
                    <div className="square-aspect-ratio-container">
                      <img
                        src={profileImage}
                        className="rounded-circle mb-1 img-fluid"
                        alt="Avatar"
                      />
                    </div>
                    <MDBCardBody className="m-0 p-0">
                      <MDBCardTitle className="text-center p-0 my-2">
                        ProfileImage
                      </MDBCardTitle>
                    </MDBCardBody>
                  </MDBCard>
                </div>

                <div className="col-xl-4 col-md-6 col-sm-5">
                  <MDBCard>
                    <MDBCardBody>
                      <MDBBtn
                        onClick={() =>
                          callSGIFPGetData(successFunc2, errorFunc)
                        }
                      >
                        +
                      </MDBBtn>
                    </MDBCardBody>
                    <div className="square-aspect-ratio-container">
                      <img
                        src={fingerprintImage}
                        className="rounded-circle mb-1 img-fluid"
                        alt="Avatar"
                      />
                    </div>
                    <MDBCardBody className="m-0 p-0">
                      <MDBCardTitle className="text-center p-0 my-2">
                        Fingerprint
                      </MDBCardTitle>
                    </MDBCardBody>
                  </MDBCard>
                </div>
                <div className="col-xl-2 col-md-3 col-sm-4"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-xxl-10 ">
          <div className="row justify-content-start mb-3 justify-content-around">
            <div className="col-sm-6 col-md-4 col-xl-3 align-self-end"></div>
          </div>
        </div>
      </div>

      {/* modal for roles and responsibilities */}

      <MDBModal
        open={roleAndResponsibilitiesModal}
        onClose={() => setRoleAndResponsibilitiesModal(false)}
        tabIndex="-1"
        size={modalSize}
      >
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Roles and Responsibilities</MDBModalTitle>
              <MDBBtn
                className="btn-close"
                color="none"
                onClick={toggleRoleAndResponsibilitiesOpen}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody style={{ maxWidth: "100%" }}>
              <div className="container">
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>Role</th>
                      <th>Responsibilities</th>
                    </tr>
                  </thead>
                  <tbody>
                    {roles.map((role, index) => (
                      <tr key={index}>
                        <td style={{ whiteSpace: "nowrap" }}>{role.role}</td>
                        <td style={{ wordBreak: "keep-all" }}>
                          {role.responsibilities}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </MDBModalBody>

            <MDBModalFooter>
              <MDBBtn onClick={toggleRoleAndResponsibilitiesOpen}>OK</MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      {/* Table of Users */}

      <div
        style={{
          maxHeight: "400px",
          overflow: "auto",
          border: "1px solid #ccc",
          borderRadius: "5px",
        }}
        className="my-5"
      >
        <MDBTable
          align="middle"
          style={{ minWidth: "600px" }}
          className="mb-0"
          hover
          responsive
        >
          <MDBTableHead>
            <tr>
              <th scope="col" style={{ whiteSpace: "nowrap" }}>
                Name
              </th>
              <th scope="col" style={{ whiteSpace: "nowrap" }}>
                Status & Last Login
              </th>
              {/* <th scope='col' style={{ whiteSpace: 'nowrap' }}>Password</th> */}
              <th scope="col" style={{ whiteSpace: "nowrap" }}>
                Role
              </th>
              <th scope="col" style={{ whiteSpace: "nowrap" }}>
                Active/Inactive
              </th>

              <th scope="col" style={{ whiteSpace: "nowrap" }}>
                Update
              </th>
            </tr>
          </MDBTableHead>
          <MDBTableBody>
            {users.map((user) => (
              <tr>
                <td>
                  <div className="d-flex align-items-center">
                    <img
                      src={user?.profileImage}
                      alt=""
                      style={{ width: "45px", height: "45px" }}
                      className="rounded-circle"
                    />
                    <div className="ms-3">
                      <p className="fw-bold mb-1">{user?.userName}</p>
                      <p className="text-muted mb-0">{user?.email}</p>
                    </div>
                  </div>
                </td>
                <td>
                  <p className="text-muted mb-0">
                    {" "}
                    <MDBBadge
                      color={user?.status === "Active" ? "success" : "danger"}
                      pill
                    >
                      {user?.status}
                    </MDBBadge>
                  </p>
                  <p className="fw-normal mb-1">
                    {fromatDateintoDDMMMMYYYY(user?.lastLogin)}
                  </p>
                </td>
                {/* <td>
                                    <p></p>
                                    <p><span >{user?.password}</span></p> 
                                </td> */}
                <td>{user?.role}</td>
                <td>
                  <MDBBtn
                    onClick={() => updateUserStatus(user?.userId)}
                    color={user?.status === "Active" ? "success" : "danger"}
                    rounded
                    size="sm"
                  >
                    {user?.status === "Active" ? (
                      <FaUserTie />
                    ) : (
                      <MdAirplanemodeActive />
                    )}
                    {/* <MdPublishedWithChanges /> */}
                  </MDBBtn>
                </td>
                <td>
                  <MDBBtn
                    onClick={() => handleGetUserDetailsById(user?.userId)}
                    color="primary"
                    rounded
                    size="sm"
                  >
                    <MdPublishedWithChanges />
                  </MDBBtn>
                </td>
              </tr>
            ))}
          </MDBTableBody>
        </MDBTable>
      </div>

      {/* Popup modal for actions */}
    </>
  );
}
